import {z} from 'zod'

export const CountrySchemaV3 = z.object({
    id: z.number(),
    name: z.string(),
    hasChilds: z.boolean().optional(),
    alpha3Code: z.string().nullable().optional(),
    alpha2Code: z.string().nullable().optional(),
    timezone: z.string(),
    currency: z.string(),
    dial: z.number(),
    languageId: z.number().nullable().optional()
})

export const CountrySchema = z.object({
    id: z.number(),
    name: z.string(),
    has_childs: z.number().optional(),
    alpha_3_code: z.string().nullable().optional(),
    alpha_2_code: z.string().nullable().optional(),
    timezone: z.string(),
    currency: z.string(),
    dial: z.number(),
    language_id: z.number().nullable().optional()
})

export const LanguageSchema = z.object({
    id: z.number(),
    name: z.string(),
    code: z.string(),
    is_translatable: z.boolean().optional()
})

export const LanguageSchemaV3 = z.object({
    id: z.number(),
    name: z.string(),
    code: z.string(),
    isTranslatable: z.boolean().optional()
})

export const CountryWithLanguageSchema = CountrySchemaV3.extend({
    language: LanguageSchema.nullable()
})

export const CitySchema = z.object({
    id: z.number(),
    name: z.string(),
    country_id: z.number().optional(),
    country: CountrySchemaV3.optional()
})
export const CitySchemaV3 = z.object({
    id: z.number(),
    name: z.string(),
    countryId: z.number().optional(),
    country: CountrySchemaV3.optional()
})

export const RegionSchema = CitySchema.extend({alpha_2_code: z.string().optional()})
export const RegionSchemaV3 = CitySchemaV3.extend({alpha2Code: z.string().optional()})

export const CountriesResponseSchema = z.array(CountrySchemaV3)
export const CountriesWithLanguageResponseSchema = z.array(CountryWithLanguageSchema)
export const RegionsResponseSchema = z.array(RegionSchema)
export const CitiesResponseSchema = z.array(CitySchema)
export const LanguagesResponseSchema = z.array(LanguageSchema)
export const LanguagesResponseSchemaV3 = z.array(LanguageSchemaV3)
